import { Lock } from "lucide-react";
import { Outlet } from "react-router";

import { useCan, type Permission } from "@/app/session/permissions";
import type { MessageId } from "@/shared/i18n/messages";
import { useT } from "@/shared/i18n/useT";
import { EmptyState } from "@/shared/ui/EmptyState";

/** A section only some roles may open: an honest explanation instead of a broken page. */
export function RequirePermission({
  permission,
  areaId,
}: {
  permission: Permission | readonly Permission[];
  areaId: MessageId;
}) {
  const t = useT();
  const allowed = useCan(permission);
  if (allowed) return <Outlet />;
  return (
    <div className="flex flex-1 items-center justify-center px-6">
      <EmptyState
        icon={Lock}
        title={t("errors.noAccess.title", { area: t(areaId) })}
        body={t("errors.noAccess.body")}
      />
    </div>
  );
}
